// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__10Y_Q","rootSuccess":"CompleteLink_rootSuccess__2F2gm","rootFailure":"CompleteLink_rootFailure__27Nn8","isDisabled":"CompleteLink_isDisabled__LYdsb"};